function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.733 13.89l-.625-.625a.389.389 0 010-.538L5.822 7 .108 1.272a.389.389 0 010-.538L.733.108a.388.388 0 01.538 0l6.62 6.623a.389.389 0 010 .538l-6.62 6.624a.388.388 0 01-.538-.002z",
  fill: "#231F20"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.733 13.89l-.625-.625a.389.389 0 010-.538L11.822 7 6.108 1.272a.389.389 0 010-.538l.625-.626a.388.388 0 01.538 0l6.62 6.623a.388.388 0 010 .538l-6.62 6.624a.388.388 0 01-.538-.002z",
  fill: "#231F20"
});

function SvgChevronsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgChevronsRight;